module.exports = __webpack_public_path__ + "img/2.aab10e84.png";